import { FileTextIcon } from 'lucide-react';
import { Heading, Paragraph } from '@/components/atoms';
import { cn } from '@/lib/utils';

interface ArticleProps {
  title: string;
  description: string;
  onClick: () => void;
  className?: string;
}

export const Article = ({
  title,
  description,
  onClick,
  className,
}: ArticleProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        'flex items-start gap-3 p-4 border border-gray-200 rounded-lg hover:border-primary hover:bg-primary/5 cursor-pointer transition-colors',
        className
      )}
    >
      <FileTextIcon className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
      <div className="flex-1">
        <Heading level={3} className="text-primary mb-1">
          {title}
        </Heading>
        <Paragraph className="text-gray-600">{description}</Paragraph>
      </div>
    </div>
  );
};
